import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  class: "table-fixed w-full [border-spacing:0.25rem] border-separate"
};
const _hoisted_2 = {
  key: 0,
  colspan: "3"
};
const _hoisted_3 = {
  class: "flex items-center justify-end"
};
const _hoisted_4 = {
  class: "w-10 text-center"
};
const _hoisted_5 = {
  class: "bg-green-50 rounded"
};
const _hoisted_6 = {
  class: "flex items-center"
};
export default /*#__PURE__*/_defineComponent({
  __name: 'MatchIncidentList',
  props: {
    match: null,
    incidents: null
  },
  setup(__props) {
    const props = __props;
    const isIncidentOnLeftSide = incident => !incident.team || incident.team.id === props.match.homeTeam.id;
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("table", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.collect(__props.incidents).reverse(), incident => {
        return _openBlock(), _createElementBlock("tr", {
          key: incident.id,
          class: "mb-2 last:mb-0"
        }, [incident.fullWidth ? (_openBlock(), _createElementBlock("td", _hoisted_2, [(_openBlock(), _createBlock(_resolveDynamicComponent(incident.component), {
          incident: incident
        }, null, 8, ["incident"]))])) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createElementVNode("td", _hoisted_3, [isIncidentOnLeftSide(incident) ? (_openBlock(), _createBlock(_resolveDynamicComponent(incident.component), {
          key: 0,
          incident: incident
        }, null, 8, ["incident"])) : _createCommentVNode("", true)]), _createElementVNode("td", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(incident.minute) + "' ", 1)]), _createElementVNode("td", _hoisted_6, [!isIncidentOnLeftSide(incident) ? (_openBlock(), _createBlock(_resolveDynamicComponent(incident.component), {
          key: 0,
          incident: incident,
          "right-side": ""
        }, null, 8, ["incident"])) : _createCommentVNode("", true)])], 64))]);
      }), 128))]);
    };
  }
});